/* Javascript Header */

// Livesearch
// document.addEventListener('DOMContentLoaded', function () {
//     var searchInput = document.querySelector('.search-form input[type="text"]');
//     var searchResultsContainer = document.querySelector('.search-products.products-livesearch');
//     var searchAutocomplete = document.querySelector('.search-autocomplete');
//     var moreResultsLink = searchAutocomplete.querySelector('.more a');
//     var moreResultsCount = searchAutocomplete.querySelector('.more span');
//     var searchOverlay = document.querySelector('.search-overlay');
//     var searchBarWrap = document.querySelector('.search-bar .search-wrap');
  
//     function liveSearch() {
//         var query = searchInput.value.trim();
  
//         if (query.length > 2) {
//             fetchSearchResults(query);
//         } else {
//             searchResultsContainer.innerHTML = '';
//             searchAutocomplete.style.display = 'none';
//             searchOverlay.classList.remove('active');
//             searchBarWrap.style.zIndex = 0;
//         }
//     }
  
//     function fetchSearchResults(query) {
//         var searchUrl = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`;
  
//         fetch(searchUrl)
//             .then(response => response.json())
//             .then(data => {
//                 displaySearchResults(data.resources.results.products);
//             })
//             .catch(error => {
//                 console.error('Error fetching search results:', error);
//                 searchResultsContainer.innerHTML = '<div class="error">Error loading search results.</div>';
//             });
//     }
  
//     function displaySearchResults(products) {
//       searchResultsContainer.innerHTML = '';
  
//       if (products.length > 0) {
//         products.forEach(function (product) {
//             var compareAtPriceHtml = product.compare_at_price_max > 0 ? `<span class="price-old">${Shopify.formatMoney(product.compare_at_price_max, "{{amount}}")}</span>` : '';
//             var productHtml = `
//                 <div class="product col-md-6">
//                     <div class="product-inner">
//                         <div class="image-wrap">
//                             <a href="${product.url}">
//                                 <img src="${product.featured_image.url}" alt="${product.title}">
//                             </a>
//                         </div>
//                         <div class="info">
//                             ${product.vendor ? `<div class="brand">${product.vendor}</div>` : ''}
//                             <a class="title" href="${product.url}">${product.title}</a>
//                             <div class="price">
//                                 ${compareAtPriceHtml}
//                                 ${Shopify.formatMoney(product.price, "{{amount}}")}
//                             </div>
//                         </div>
//                     </div>
//                 </div>`;
  
//             searchResultsContainer.innerHTML += productHtml;
//         });
  
//         moreResultsLink.href = `/search?type=product&q=${encodeURIComponent(searchInput.value.trim())}`;
//         moreResultsCount.textContent = `(${products.length})`;
//         searchAutocomplete.classList.remove('noresults');
//     } else {
//         searchResultsContainer.innerHTML = '<div class="notfound">{{ "sections.header.no_products_found" | t }}...</div>';
//         searchAutocomplete.classList.add('noresults');
//     }
  
//       searchAutocomplete.style.display = 'block';
//       searchOverlay.classList.add('active');
//       searchBarWrap.style.zIndex = '9999';
//     }
  
//     searchInput.addEventListener('keyup', liveSearch);
//   });


/* Javascript Footer */

// FOOTER TABS
$(function(){
    if ($(window).width() < 992) {
        $('#footer .main-footer .col.mob-slide .footer-title').on('click', function(){
        var $this = $(this);
        if (!$this.hasClass('active')) {
          $('#footer .main-footer .footer-title.active').removeClass('active');
          $(this).addClass('active');
          $('#footer .main-footer .content-wrap.active').removeClass('active').slideToggle(300);
          $(this).parent().find('.content-wrap').addClass('active').slideToggle(300);
        } else {
          $('#footer .main-footer .footer-title.active').removeClass('active');
          $('#footer .main-footer .content-wrap.active').removeClass('active').slideToggle(300);
        }
      });    	
    }
});

/* Javascript Mobile Menu */

// MOBILE MENU //
$('.mobile-menu .menu ul li .more-cats').on('click', function(e){
    e.preventDefault();
    var cur = $(this);
    setTimeout(function(){
        cur.closest('li').find('.subs').first().addClass('active');
        subsHeight();
    }, 50);
    cur.closest('.popup-inner').animate({scrollTop: 0}, 0);
});

$('.mobile-menu .subs-back').on('click', function(){
    $(this).closest('.subs').removeClass('active');
    subsHeight();
});

/* Javascript Global */
function checkLoop(loopItems, maxItems){
    var setLoop = false;
    if(loopItems > maxItems){
        setLoop =  true;
    }
    return setLoop;  
}   

function setLoop(loopItems, maxItems){
    if($.isNumeric(maxItems)){
        return checkLoop(loopItems, maxItems);
    } else {
        if (maxItems.indexOf('|') != -1) {
            var splitItems = maxItems.split('|');
        
        if($(window).width() >= 1200){
            return checkLoop(loopItems, splitItems[0]);
        } else if($(window).width() >= 992){
            return checkLoop(loopItems, splitItems[1]);
            } else if($(window).width() >= 768){
            return checkLoop(loopItems, splitItems[2]);
        } else { 
            return checkLoop(loopItems, splitItems[3]);
        }
        }
    }
}